
import { mxRectangle as MxRectangle } from 'mxgraph-js';
import HCLVertexState from '../../HCLCellState/HCLVertexState';
import BasicEventVertex from '../../HCLTreeNode/FaultTreeNode/BasicEventNode/BasicEventVertex';
import BasicEventVertexDetailedShape from '../../HCLCellShape/FaultTree/BasicEvent/BasicEventVertexDetailedShape';
import Utility from '../../../Utility';
import HCLText from '../HCLText';

/**
 * SubLabel contains a formatted value string for this node type
 */
class SubLabel extends HCLText {
  constructor() {
    super();
  }

  getValue(state: HCLVertexState): string {
    const cell = state.getCell();
    const scale = cell.getGraph().getView().getScale();
    return Utility.truncate(cell.getValue().getFormattedSubLabel(), this.bounds.width / (this.size * scale * 0.625));
  }

  getBounds(state: HCLVertexState): MxRectangle {
    const scale = state.getCell().getGraph().getView().getScale();
    return new MxRectangle(
      state.x + 8 * scale,
      state.y + state.height - (BasicEventVertex.SHAPE.GATE + BasicEventVertexDetailedShape.SUB_LABEL_HEIGHT / 3) * scale,
      state.width,
      state.height,
    );
  }
}

export default SubLabel;
